<div class="modal-header">
  <h3 class="modal-title" (contextmenu)="mainService.showDebugInfo($event, null, item)">Historie voor Vrooam CAB ID
    {{item.VrmArticleId}} van leverancier {{item.SupplierName}}</h3>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table table-striped  table-bordered table-sm small text-nowrap">
      <thead>
        <tr class="table-dark">
          @for (key of keys; track key) {
          <td>{{key}}</td>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>huidige waardes</td>
          <td>-</td>
          @for (key of keys.slice(2); track key) {
          @if (isDateKey(key)) {
          <td>{{item[key] | date : 'dd-MM-yyyy HH:mm'}}</td>
          } @else {
          <td>{{item[key]}}</td>
          }
          }
        </tr>
        @for (art of item.History; track art; let i = $index) {
        @let prevArt = i>0?item.History[i-1]:item;
        <tr>
          @for (key of keys; track key) {
          @let changed = (art[key]!==prevArt[key]) && trackChange(key);
          @if (isDateKey(key)) {
          <td [ngClass]="{'text-danger': changed}">{{art[key] | date : 'dd-MM-yyyy HH:mm'}}</td>
          } @else {
          <td [ngClass]="{'text-danger': changed}">{{art[key]}}</td>
          }
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">Sluiten</button>
</div>